import { useTranslation } from "react-i18next";
import { BenefitItem, benefits } from "~/features/benefits/Benefits";

export function ProductBenefits() {
  const { t } = useTranslation();
  return (
    <section className="flex w-full flex-col gap-12">
      <h2>{t("CaboCheck Vorteile")}</h2>
      <div className="grid w-full grid-cols-2 gap-4">
        {benefits.map((benefit) => (
          <BenefitItem key={benefit.id} benefit={benefit} />
        ))}
      </div>
    </section>
  );
}
